import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { staticCatalogs } from 'utils/catalogs/staticCatalogs';
import { catalogList } from 'utils/catalogs/keys';

import CatalogsContext from './context';
import type { OnboardingCatalogType } from './types';

type Props = {
  children: React.ReactNode;
};

const CatalogsProvider = ({ children }: Props) => {
  const queryClient = useQueryClient();
  const [onboardingCatalogs, setOnboardingCatalogs] =
    useState<OnboardingCatalogType>({
      loaded: false,
      error: false,
      ...staticCatalogs,
      ...catalogList,
    });

  const updateOnboardingCatalogs = (newValues: OnboardingCatalogType) => {
    setOnboardingCatalogs({ ...staticCatalogs, ...newValues });
  };

  const resetCatalogsValues = async () => {
    setOnboardingCatalogs({
      loaded: false,
      error: false,
      ...staticCatalogs,
      ...catalogList,
    });

    await queryClient.invalidateQueries({
      queryKey: ['global-catalogs'],
    });
  };
  return (
    <CatalogsContext.Provider
      value={{
        onboardingCatalogs,
        updateOnboardingCatalogs,
        resetCatalogsValues,
      }}
    >
      {children}
    </CatalogsContext.Provider>
  );
};

export default CatalogsProvider;
